<template>
  <div class="source-content shoppable">
    <div class="flex items-center gap-3 px-3 pt-3">
      <div class="breadcrumbs flex min-w-0 flex-1 items-center gap-1 overflow-hidden">
        <button
          class="flex-none border-0 bg-transparent p-0 text-[11px] leading-none text-producer-slate-textWeak transition hover:text-producer-slate-textWeak disabled:text-producer-slate-textWeak"
          data-entity="producer-assets-backToCollections"
          :disabled="showCollections"
          @click="resetAll"
        >
          <span class="fak fa-rectangle-vertical-history-regular"></span>
          Collections
        </button>

        <div
          v-if="!showCollections && selectedCollectionData"
          class="min-w-0 truncate"
          :title="selectedCollectionData.name"
        >
          <!-- keep for whitespace -->
          /
          {{ selectedCollectionData.name }}
        </div>
      </div>

      <button
        class="tb-btn tb-btn-contained medium-em flex-none shrink-0"
        data-entity="producer-assets-browseCatalog"
        data-test="producer-shoppable-browseCatalog"
        @click="openCatalogModal"
      >
        <span class="far fa-cart-plus"></span>
        Browse Catalog
      </button>
    </div>

    <collection-list v-if="showCollections"/>

    <product-list
      v-else
      :collection-id="selectedCollection"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import tabMixins from '@/js/mixins/tab-mixins';

import CollectionList from './CollectionList.vue';
import ProductList from './ProductList.vue';

export default {
  mixins: [tabMixins],
  name: 'Shoppable',
  components: {
    CollectionList,
    ProductList,
  },
  computed: {
    ...mapState('shoppable', [
      'isLoadingCollections',
      'selectedCollection',
      'collections',
      'collectionSearch',
    ]),
    ...mapGetters('shoppable', [
      'selectedCollectionData',
    ]),

    showCollections() {
      return this.isLoadingCollections
        || (!this.selectedCollection && !!this.collectionSearch) // searching collections, no results
        || (!this.selectedCollection && !!this.collections.length); // user has no collections so just show products
    },
  },
  async created() {
    try {
      await this.getCollections();
      if (!this.collections.length) {
        // no collections, default to "all saved products"
        this.setSelectedCollection(-1);
      }
    } catch (error) {
      this.errorToast('Failed to load Collections.');
    }
  },
  methods: {
    ...mapActions('shoppable', [
      'getCollections',
      'incrementCollectionPage',
      'openCatalogModal',
      'closeCatalogModal',
      'searchProducts',
      'resetProductSearch',
      'setSelectedCollection',
      'openCatalogModal',
      'resetCollectionSearch',
    ]),

    onMove() {
      return -1; // always add to front so the list can pop off the last item
    },

    resetAll() {
      this.setSelectedCollection(null);
      this.resetProductSearch();

      if (!this.collections.length) {
        this.resetCollectionSearch();
      }
    },
  },
};
</script>
